import React, { useEffect } from 'react';
import RecordOrEquivalent from './components/RecordOrEquivalent';
import HealthAndWelfare from './components/HealthAndWelfare';
import { LpaType } from './utils';
import {
  SuccessNotiPositionEnum,
  ShowSuccessNotificationType,
} from '../../../commons';

interface LPAProps {
  userId: string;
  lpa: LpaType;
  setLpa: React.Dispatch<React.SetStateAction<LpaType>>;
  lpaFromData: LpaType;
  onSaveInLpa: (e: any, position: SuccessNotiPositionEnum) => void;
  showSuccessNotification: ShowSuccessNotificationType;
}

const LPA: React.FC<LPAProps> = ({
  userId,
  lpa,
  setLpa,
  lpaFromData,
  onSaveInLpa,
  showSuccessNotification,
}) => {
  useEffect(() => {
    if (lpaFromData) {
      setLpa(lpaFromData);
    }
  }, [lpaFromData, setLpa]);

  return (
    <div>
      <RecordOrEquivalent />
      <HealthAndWelfare
        userId={userId}
        lpa={lpa}
        setLpa={setLpa}
        lpaFromData={lpaFromData}
        showSuccessNotification={showSuccessNotification}
        onSaveInLpa={onSaveInLpa}
      />
    </div>
  );
};

export default LPA;
